import React, {useEffect, useState} from "react";
import {bindActionCreators} from "redux";
import customerActionsImp from "../../../Actions/customerActions";
import {useDispatch, useSelector} from "react-redux";
import {customerFields, VossCreateForm} from "../../../Utils/customerFormUtils";
import formActionsImp from "../../../Actions/formActions";
import helpers from "../../../Utils/helpers";
import forms from "../../../Constants/forms";
import useCustomerExpiryDate from "../../../Hooks/Customer/useCustomerExpiryDate";
import TargetGroupActionsImp from "../../../Actions/Voss/targetGroupActions";
import {targetGroups as TargetGroups} from "../../../Constants/VOSS/targetGroups";
import * as formValidationRules from "../../../Constants/formValidationRules";
import {CustomerForm} from "./CustomerForm";

export const CreateVossCustomerForm = ({}) => {
    const dispatch = useDispatch();
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    const form = useSelector((state) => state.FormReducer.forms.customerFormData);
    const formActions = bindActionCreators(formActionsImp, dispatch);
    const [businessCheck, setBusinessCheck] = useState(false);
    const businessCheckLoading = useSelector((state) => state.CommonReducer.dataLoading.customerFromBusinessCheck);
    const targetGroupsActions = bindActionCreators(TargetGroupActionsImp, dispatch);
    const targetGroups = useSelector((state) => state.TargetGroupsReducer.targetGroups);
    const { showExpiryDate } = useCustomerExpiryDate(form);
    const [validationRules, setValidationRules] = useState(formValidationRules.VossCustomerForm);

    useEffect(() => {
        if (!form) {
            const leadId = helpers.getUrlQueryParameter(window.location, "leadId");
            const input = helpers.getUrlQueryParameter(window.location, "input");
            customerActions.beginVossCustomerCreation(forms.customerFormData, input, leadId);
        }

        if (!targetGroups) {
            targetGroupsActions.getTargetGroups();
        }

    }, []);

    function initTestCustomer() {
        setBusinessCheck(true);
        
        const testTargetGroup = targetGroups?.find(x => x.name === TargetGroups.TestCustomer.name);
        formActions.changeAndValidateMultiFormField(form, customerFields.targetGroups.name, [{
            name: testTargetGroup.name,
            id: testTargetGroup.id
        }]);

        formActions.changeMultiFormField(form, customerFields.testCustomer.name, true);
    }

    useEffect(() => {
        if (!form?.data?.testCustomer && form?.data?.organizationNumber?.length >= 10) {
            setBusinessCheck(false);
            customerActions.createVossCustomerFromBusinessCheck(form, forms.customerFormData, () => setBusinessCheck(true));
        }
    }, [form?.data?.organizationNumber]);

    useEffect(() => {
        if (!form) return;

        if (form?.data?.testCustomer) {
            customerActions.createTestCustomer(forms.customerFormData, () => initTestCustomer());
        } else {
            formActions.changeMultiFormField(form, customerFields.organizationNumber.name, "");
            formActions.changeAndValidateMultiFormField(form, customerFields.targetGroups.name, []);
        }
    }, [form?.data?.testCustomer])

    function updateFormValidationRules() {
        let rules = formValidationRules.VossCustomerForm;
        
        if (form?.data?.testCustomer) {
            rules = [
                ...rules,
                ...formValidationRules.VossTestCustomerForm
            ];
        }
        
        setValidationRules(rules);
    }

    useEffect(() => {
        if (!form) return;

        formActions.updateFormValidationRules(form.id, validationRules);
    }, [validationRules]);

    useEffect(() => {
        updateFormValidationRules();
    }, [form?.data?.targetGroups, targetGroups, form?.data?.testCustomer]);
    

    const params = {
        businessCheck: businessCheck,
        businessCheckLoading: businessCheckLoading,
        testCustomer: form?.data?.testCustomer,
        showExpiryDate: showExpiryDate
    };
    
    if (!form) {
        return null;
    }
    return <CustomerForm
        columns={VossCreateForm()}
        form={form}
        fieldParams={params}
    />
}